import React, { useState } from 'react'
import './BenchmarkSidebar.css'

/**
 * 벤치마킹 분석 사이드바
 */
function BenchmarkSidebar({ 
  benchmarkSettings,
  setBenchmarkSettings,
  savedChannels = [],
  onSaveChannel,
  onRemoveChannel,
  isOpen = true,
  youtubeUrl = '',
  onYoutubeUrlChange,
  onYoutubeUrlSubmit,
  isLoadingMetadata = false,
  selectedVideo = null,
  onDownloadVideo,
  onExtractAudio
}) {
  const [activeSection, setActiveSection] = useState('settings')

  // 설정 업데이트
  const updateSetting = (key, value) => {
    const newSettings = {
      ...benchmarkSettings,
      [key]: value
    }
    setBenchmarkSettings(newSettings)
  }

  return (
    <div className={`benchmark-sidebar ${isOpen ? 'open' : 'closed'}`}>
      {/* 사이드바 헤더 */}
      <div className="benchmark-sidebar-header">
        <h3>벤치마킹 설정</h3>
      </div>

      {/* 탭 네비게이션 */}
      <div className="sidebar-tabs">
        <button 
          className={`tab-btn ${activeSection === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveSection('settings')}
        >
          설정
        </button>
        <button 
          className={`tab-btn ${activeSection === 'saved' ? 'active' : ''}`}
          onClick={() => setActiveSection('saved')}
        >
          저장된 채널
        </button>
        <button 
          className={`tab-btn ${activeSection === 'api' ? 'active' : ''}`}
          onClick={() => setActiveSection('api')}
        >
          API 설정
        </button>
      </div>

      {/* 사이드바 컨텐츠 */}
      <div className="benchmark-sidebar-content">
        {/* YouTube URL 입력 섹션 - 모든 탭에서 표시 */}
        <div className="youtube-url-sidebar-section">
          <div className="url-input-container">
            <input
              type="text"
              className="youtube-url-input"
              placeholder="YouTube URL을 입력하세요"
              value={youtubeUrl}
              onChange={(e) => onYoutubeUrlChange(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && onYoutubeUrlSubmit()}
            />
            <button 
              className="url-submit-btn"
              onClick={onYoutubeUrlSubmit}
              disabled={isLoadingMetadata}
            >
              {isLoadingMetadata ? '분석 중...' : '불러오기'}
            </button>
          </div>
          <p className="url-hint">YouTube 인기 영상에서 클릭하면 자동으로 입력됩니다</p>
          
          {/* 영상 다운로드 및 오디오 추출 버튼 - 영상이 선택된 경우에만 표시 */}
          {selectedVideo && selectedVideo.id && (
            <div className="download-buttons">
              <button 
                className="download-video-btn"
                onClick={() => onDownloadVideo && onDownloadVideo(selectedVideo)}
                style={{
                  width: '48%',
                  marginTop: '10px',
                  marginRight: '4%',
                  padding: '10px',
                  background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.3s'
                }}
              >
                📥 영상 다운로드
              </button>
              <button 
                className="extract-audio-btn"
                onClick={() => onExtractAudio && onExtractAudio(selectedVideo ? { ...selectedVideo, url: youtubeUrl } : { url: youtubeUrl })}
                style={{
                  width: '48%',
                  marginTop: '10px',
                  padding: '10px',
                  background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.3s'
                }}
              >
                🎵 오디오 추출
              </button>
            </div>
          )}
        </div>

        {/* 설정 섹션 - 빈 상태 */}
        {activeSection === 'settings' && (
          <div className="settings-section">
            {/* 추가 설정이 필요하면 여기에 */}
          </div>
        )}

        {/* 저장된 채널 섹션 - 빈 상태 */}
        {activeSection === 'saved' && (
          <div className="saved-section">
            {/* 내용 제거 - 빈 섹션 */}
          </div>
        )}

        {/* API 설정 섹션 - 빈 상태 */}
        {activeSection === 'api' && (
          <div className="api-section">
            {/* 내용 제거 - 빈 섹션 */}
          </div>
        )}
      </div>

      {/* 사이드바 푸터 */}
      <div className="benchmark-sidebar-footer">
        <div className="footer-info">
          <span className="info-text">마지막 분석: 2시간 전</span>
          <button className="help-btn">도움말</button>
        </div>
      </div>
    </div>
  )
}

export default BenchmarkSidebar